// extracted by mini-css-extract-plugin
module.exports = {"recommendationDate":"styles_recommendationDate__1Vj0n","treatmentDetails":"styles_treatmentDetails__qC24R","treatmentTitle":"styles_treatmentTitle__wQsgg"};